module.exports = __webpack_public_path__ + "media/application/images/ui/plus-minus-582ebc8961baf0a9135f9321c0a1b0ad.png";